/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ prospectNames: NonNullable<unknown> }} Coinvestments_Addopportunityowner_Error3Inputs */

const en_coinvestments_addopportunityowner_error3 = /** @type {(inputs: Coinvestments_Addopportunityowner_Error3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to edit opportunity owner for some organisations: ${i?.prospectNames}. Please try again.`)
};

/**
* | output |
* | --- |
* | "Failed to edit opportunity owner for some organisations: {prospectNames}. Please try again." |
*
* @param {Coinvestments_Addopportunityowner_Error3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_addopportunityowner_error3 = /** @type {((inputs: Coinvestments_Addopportunityowner_Error3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Addopportunityowner_Error3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_addopportunityowner_error3(inputs)
});
export { coinvestments_addopportunityowner_error3 as "coInvestments_addOpportunityOwner_error" }